import { Typography } from '@mui/material';
import { Box } from '@mui/system';

import { Button, ModalContentContainer } from '@/components';
import { IterableSubscriptionGroup } from '@/types';

export type EmailToggleWarningProps = {
  warningMessage: IterableSubscriptionGroup['warningMessage'];
  onConfirm: () => void;
  onCancel: () => void;
};

export const EmailToggleWarning = ({
  warningMessage,
  onConfirm,
  onCancel,
}: EmailToggleWarningProps) => {
  return (
    <Box sx={{ maxWidth: 600 }}>
      <ModalContentContainer stretch>
        <Typography variant="h3" sx={{ mb: 3 }}>
          {warningMessage?.heading}
        </Typography>
        <Typography variant="body1">{warningMessage?.body}</Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 2,
            mt: 4,
          }}>
          <Button
            variant="secondary"
            label="Keep Emails On"
            fullWidth={false}
            skinny={false}
            sx={{ width: '50%' }}
            onClick={onCancel}
          />
          <Button
            variant="primary"
            label="Unsubscribe"
            fullWidth={false}
            skinny={false}
            sx={{ width: '50%' }}
            onClick={onConfirm}
          />
        </Box>
      </ModalContentContainer>
    </Box>
  );
};
